<template>
  <v-app id="inspire">
    <v-toolbar color="indigo" dark fixed app>
      <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
      <v-toolbar-title>Scoring Interface</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="signout">Signout</v-btn>
      <v-dialog v-model="trancheDialog" max-width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedTranche.name"
                    label="Tranche Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedTranche.percentile"
                    type="number"
                    label="Percentile"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeTranche"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" flat @click="saveTranche">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="weightedTypeDialog" max-width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">New Weighted Type</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-select
                    label="Company Type"
                    v-model="editedWeightedType"
                    :items="companyTypes"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeWeightedType"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" flat @click="saveWeightedType"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="excludedTypeDialog" max-width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">New Excluded Type</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-select
                    label="Company Type"
                    v-model="editedExcludedType"
                    :items="companyTypes"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeExcludedType"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" flat @click="saveExcludedType"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-content pa-0 pt-12>
      <v-flex xs12 sm8 offset-sm2 pa-2>
        <v-card>
          <v-subheader>Scoring Factors</v-subheader>
          <v-form>
            <v-container fluid>
              <v-layout>
                <v-flex xs12 sm8 offset-sm2>
                  <v-card>
                    <v-subheader
                      >Property Weights (Must Sum to 100%)</v-subheader
                    >
                    <v-layout row align-center justify-start fill-height pa-2>
                      <v-flex sm3 justify-center align-center pr-5>
                        <v-text-field
                          label="Age"
                          v-model="propAgeCoef"
                          suffix="%"
                          :error-messages="validatePropertyScores()"
                          style="text-align: right"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3 justify-center align-center pr-5>
                        <v-text-field
                          label="Quality"
                          v-model="propQualCoef"
                          suffix="%"
                          :error-messages="validatePropertyScores()"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-form>
            <v-container fluid>
              <v-layout>
                <v-flex xs12 sm8 offset-sm2>
                  <v-card>
                    <v-subheader
                      >Company Weights (Must Sum to 100%)</v-subheader
                    >
                    <v-layout row align-center justify-start fill-height pa-2>
                      <v-layout row align-center justify-start fill-height pa-2>
                        <v-flex sm3 justify-center align-center pr-5>
                          <v-text-field
                            label="Relationship"
                            v-model="compRelCoef"
                            suffix="%"
                            :error-messages="validateCompanyScores()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm3 justify-center align-center pr-5>
                          <v-text-field
                            label="Type"
                            v-model="compTypeCoef"
                            suffix="%"
                            :error-messages="validateCompanyScores()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm3 justify-center align-center pr-5>
                          <v-text-field
                            label="Prop. Score"
                            v-model="compPropCoef"
                            suffix="%"
                            :error-messages="validateCompanyScores()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm3 justify-start align-center pr-5>
                          <v-text-field
                            label="RSF"
                            v-model="compSqftCoef"
                            suffix="%"
                            :error-messages="validateCompanyScores()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm3 justify-center align-center pr-5>
                          <v-text-field
                            label="Prop. Count"
                            v-model="compPropNumCoef"
                            suffix="%"
                            :error-messages="validateCompanyScores()"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm8 offset-sm2>
                <v-card>
                  <v-subheader>Company Properties</v-subheader>
                  <v-layout row align-center justify-start fill-height pa-2>
                    <v-flex justify-center align-center pr-5>
                      <v-checkbox
                        v-model="allProperties"
                        label="Use 'linked' properties in addition to owned properties"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm8 offset-sm2>
                <v-card>
                  <v-subheader>Company Types To Be Weighted</v-subheader>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-on="on"
                    @click="newWeightedType"
                    >New Type</v-btn
                  >
                  <v-list>
                    <v-list-tile v-for="item in weightedTypes" :key="item">
                      <v-list-tile-content>
                        <v-list-tile-title v-text="item"></v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon ripple>
                          <v-icon
                            @click="deleteWeightedType(item)"
                            color="grey lighten-1"
                            >delete</v-icon
                          >
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 sm8 offset-sm2 pa-2>
        <v-card>
          <v-subheader>Tranching</v-subheader>
          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm8 offset-sm2>
                <v-card>
                  <v-subheader>Tranching</v-subheader>

                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-on="on"
                    @click="newTranche"
                    >New Tranche</v-btn
                  >
                  <v-data-table
                    :headers="tableHeaders"
                    :items="tranches"
                    class="elevation-1"
                    hide-actions
                  >
                    <template slot="items" slot-scope="p">
                      <td>{{ p.item.name }}</td>
                      <td>{{ p.item.percentile }}</td>
                      <td class="layout px-0">
                        <v-icon small class="mr-2" @click="editTranche(p.item)"
                          >edit</v-icon
                        >
                        <v-icon small @click="deleteTranche(p.item)"
                          >delete</v-icon
                        >
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm8 offset-sm2>
                <v-card>
                  <v-subheader
                    >Company Types To Be Removed From Tranching</v-subheader
                  >
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-on="on"
                    @click="newExcludedType"
                    >New Type</v-btn
                  >
                  <v-list>
                    <v-list-tile v-for="item in excludedTypes" :key="item">
                      <v-list-tile-content>
                        <v-list-tile-title v-text="item"></v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon ripple>
                          <v-icon
                            @click="deleteExcludedType(item)"
                            color="grey lighten-1"
                            >delete</v-icon
                          >
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm8 offset-sm2>
                <v-card>
                  <v-subheader>Relationship Scores to be Tranched</v-subheader>
                  <v-layout row wrap>
                    <v-flex xs2 offset-sm2>
                      <v-checkbox
                        v-model="trancheRel0"
                        :label="`0`"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs2 offset-sm2>
                      <v-checkbox
                        v-model="trancheRel1"
                        :label="`1`"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs2 offset-sm2>
                      <v-checkbox
                        v-model="trancheRel2"
                        :label="`2`"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs2 offset-sm2>
                      <v-checkbox
                        v-model="trancheRel3"
                        :label="`3`"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs2 offset-sm2>
                      <v-checkbox
                        v-model="trancheRel4"
                        :label="`4`"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-container fluid>
        <v-layout justify-center align-start>
          <v-btn round color="info" v-on:click="run" :disabled="buttonDisabled"
            >Run</v-btn
          >
        </v-layout>
      </v-container>

      <v-container fluid>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card>
              <v-subheader>Results</v-subheader>
              <download-excel
                class="v-btn primary"
                :data="results"
                type="csv"
                name="Company-Scores.csv"
                >Export</download-excel
              >
              <v-data-table
                :headers="resultHeaders"
                :items="results"
                class="elevation-1"
              >
                <template slot="items" slot-scope="r">
                  <td>{{ r.item.id }}</td>
                  <td>{{ r.item.name }}</td>
                  <td>{{ r.item.type }}</td>
                  <td>
                    {{ Math.round(r.item.score * 100) / 100 }}
                  </td>
                  <td>{{ r.item.tranche }}</td>
                  <td>
                    {{ Math.round(r.item.relationshipScore * 100) / 100 }}
                  </td>
                  <td>
                    {{ Math.round(r.item.typeScore * 100) / 100 }}
                  </td>
                  <td>
                    {{ Math.round(r.item.sqftScore * 100) / 100 }}
                  </td>
                  <td>
                    {{ Math.round(r.item.averagePropertyScore * 100) / 100 }}
                  </td>
                  <td>
                    {{ Math.round(r.item.propertyNumScore * 100) / 100 }}
                  </td>
                  <td>{{ r.item.propertyCount }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid>
        <v-layout justify-center align-start>
          <v-btn
            round
            color="info"
            v-on:click="apply"
            :disabled="buttonDisabled"
            >Apply</v-btn
          >
        </v-layout>
      </v-container>
    </v-content>
    <v-footer color="indigo" app>
      <span class="white--text">&copy; 2019 RealSource Group</span>
      <v-spacer></v-spacer>
      <span class="white--text">{{ info }}</span>
    </v-footer>
  </v-app>
</template>

<script>
const axios = require("axios");
const utils = require("./utils");
// const url = 'https://dev-app.rsgcrm.com'
const url = "https://app.rsgcrm.com";
// const url = "http://localhost:8080";

export default {
  data: () => ({
    running: false,
    propAgeCoef: 80,
    propQualCoef: 20.0,
    compRelCoef: 80.0,
    compTypeCoef: 10.0,
    compPropCoef: 9.99,
    compSqftCoef: 0.01,
    compPropNumCoef: 0.0,
    info: "Ready",
    buttonDisabled: false,

    allProperties: false,

    trancheDialog: false,
    weightedTypeDialog: false,
    excludedTypeDialog: false,

    trancheRel0: true,
    trancheRel1: true,
    trancheRel2: true,
    trancheRel3: true,
    trancheRel4: true,

    resultHeaders: [
      { text: "Company ID", value: "id", sortable: true },
      { text: "Name", value: "name", sortable: true },
      { text: "Type", value: "type", sortable: true },
      { text: "Score", value: "score", sortable: true },
      { text: "Tranche", value: "tranche", sortable: true },
      {
        text: "Relationship Score",
        value: "relationshipScore",
        sortable: true,
      },
      { text: "Type Score", value: "typeScore", sortable: true },
      { text: "SQFT Score", value: "sqftScore", sortable: true },
      {
        text: "Average Property Score",
        value: "averagePropertyScore",
        sortable: true,
      },
      {
        text: "Property Num Score",
        value: "propertyNumScore",
        sortable: true,
      },
      { text: "Property Count", value: "propertyCount", sortable: true },
    ],

    results: [],

    tableHeaders: [
      { text: "Name", value: "name", sortable: false },
      { text: "Percentile", value: "percentile", sortable: false },
      { text: "Actions", value: "name", sortable: false },
    ],
    tranches: [],
    editedWeightedType: "",
    editedExcludedType: "",
    weightedTypes: [],
    excludedTypes: [],
    editedTrancheIndex: -1,
    editedTranche: {
      name: "",
      percentile: 0,
    },
    defaultTranche: {
      name: "",
      percentile: 0,
    },
    companyTypes: [
      "Contractor",
      "Developer",
      "Government",
      "Health System",
      "HNW/Private",
      "Institutional Investor",
      "Investment Advisor",
      "Lender",
      "Operator",
      "PE Investor",
      "Physicians",
      "Practice Group",
      "REIT",
      "Service Provider",
      "SPE",
    ],
  }),

  computed: {
    formTitle() {
      return this.editedTrancheIndex === -1 ? "New Tranche" : "Edit Tranche";
    },
  },

  watch: {
    trancheDialog(val) {
      val || this.closeTranche();
    },
    weightedTypeDialog(val) {
      val || this.closeWeightedType();
    },
    excludedTypeDialog(val) {
      val || this.closeExcludedType();
    },
  },

  props: {
    source: String,
  },

  methods: {
    convert() {
      var propAgeCoefFl = parseFloat(this.propAgeCoef);
      this.propAgeCoef = isNaN(propAgeCoefFl)
        ? this.propAgeCoef
        : propAgeCoefFl;

      var propQualCoefFl = parseFloat(this.propQualCoef);
      this.propQualCoef = isNaN(propQualCoefFl)
        ? this.propQualCoef
        : propQualCoefFl;

      var compRelCoefFl = parseFloat(this.compRelCoef);
      this.compRelCoef = isNaN(compRelCoefFl)
        ? this.compRelCoef
        : compRelCoefFl;

      var compTypeCoefFl = parseFloat(this.compTypeCoef);
      this.compTypeCoef = isNaN(compTypeCoefFl)
        ? this.compTypeCoef
        : compTypeCoefFl;

      var compPropCoefFl = parseFloat(this.compPropCoef);
      this.compPropCoef = isNaN(compPropCoefFl)
        ? this.compPropCoef
        : compPropCoefFl;

      var compSqftCoefFl = parseFloat(this.compSqftCoef);
      this.compSqftCoef = isNaN(compSqftCoefFl)
        ? this.compSqftCoef
        : compSqftCoefFl;

      var compPropNumCoefFl = parseFloat(this.compPropNumCoef);
      this.compPropNumCoef = isNaN(compPropNumCoefFl)
        ? this.compPropNumCoef
        : compPropNumCoefFl;

      for (var i = 0; i < this.tranches.length; i++) {
        var perFl = parseFloat(this.tranches[i].percentile);
        this.tranches[i].percentile = isNaN(perFl)
          ? this.tranches[i].percentile
          : perFl;
      }
    },
    run() {
      let jwt = window.sessionStorage.getItem("token");

      this.info = "Running";
      this.running = true;
      this.results = [];
      this.buttonDisabled = true;
      this.convert();
      axios
        .post(
          url + "/api/score",
          {
            parameters: {
              propAgeCoef: this.propAgeCoef / 100,
              propQualCoef: this.propQualCoef / 100,
              compRelCoef: this.compRelCoef / 100,
              compTypeCoef: this.compTypeCoef / 100,
              compPropCoef: this.compPropCoef / 100,
              compSqftCoef: this.compSqftCoef / 100,
              compPropNumCoef: this.compPropNumCoef / 100,
              tranches: this.tranches || [],
              weightedTypes: this.weightedTypes || [],
              excludedTypes: this.excludedTypes || [],
              syncOR: false,
              syncRN: false,
              trancheRel0: this.trancheRel0,
              trancheRel1: this.trancheRel1,
              trancheRel2: this.trancheRel2,
              trancheRel3: this.trancheRel3,
              trancheRel4: this.trancheRel4,
              allProperties: this.allProperties,
            },
          },
          {
            headers: { Authorization: `Bearer ${jwt}` },
          }
        )
        .catch((error) => (this.info = error.response.statusText));
    },
    apply() {
      let jwt = window.sessionStorage.getItem("token");

      this.info = "Applying";
      this.running = true;
      this.results = [];
      this.buttonDisabled = true;
      this.convert();
      axios
        .post(
          url + "/api/score",
          {
            parameters: {
              propAgeCoef: this.propAgeCoef / 100,
              propQualCoef: this.propQualCoef / 100,
              compRelCoef: this.compRelCoef / 100,
              compTypeCoef: this.compTypeCoef / 100,
              compPropCoef: this.compPropCoef / 100,
              compSqftCoef: this.compSqftCoef / 100,
              compPropNumCoef: this.compPropNumCoef / 100,
              tranches: this.tranches || [],
              weightedTypes: this.weightedTypes || [],
              excludedTypes: this.excludedTypes || [],
              syncOR: true,
              syncRN: true,
              trancheRel0: this.trancheRel0,
              trancheRel1: this.trancheRel1,
              trancheRel2: this.trancheRel2,
              trancheRel3: this.trancheRel3,
              trancheRel4: this.trancheRel4,
              allProperties: this.allProperties,
            },
          },
          {
            headers: { Authorization: `Bearer ${jwt}` },
          }
        )
        .catch((error) => (this.info = error.response.statusText));
    },
    setStatus(data) {
      this.info = data.status;
      if (data.status === "Running") {
        this.buttonDisabled = true;
      } else {
        this.buttonDisabled = false;
      }

      if (this.running && data.status === "Ready") {
        this.running = false;
        this.results = data.results || [];
      }
    },
    setForm(data) {
      this.propAgeCoef = data.parameters.propAgeCoef * 100;
      this.propQualCoef = data.parameters.propQualCoef * 100;
      this.compRelCoef = data.parameters.compRelCoef * 100;
      this.compTypeCoef = data.parameters.compTypeCoef * 100;
      this.compPropCoef = data.parameters.compPropCoef * 100;
      this.compSqftCoef = data.parameters.compSqftCoef * 100;
      this.compPropNumCoef = data.parameters.compPropNumCoef * 100;
      this.tranches = data.parameters.tranches || [];
      this.weightedTypes = data.parameters.weightedTypes || [];
      this.excludedTypes = data.parameters.excludedTypes || [];
      this.syncOR = data.parameters.syncOR;
      this.syncRN = data.parameters.syncRN;
      this.trancheRel0 = data.parameters.trancheRel0;
      this.trancheRel1 = data.parameters.trancheRel1;
      this.trancheRel2 = data.parameters.trancheRel2;
      this.trancheRel3 = data.parameters.trancheRel3;
      this.trancheRel4 = data.parameters.trancheRel4;
      this.allProperties = data.parameters.allProperties;
      this.results = data.results || [];
    },
    newTranche() {
      this.trancheDialog = true;
    },
    editTranche(tranche) {
      this.editedTrancheIndex = this.tranches.indexOf(tranche);
      this.editedTranche = Object.assign({}, tranche);
      this.trancheDialog = true;
    },

    deleteTranche(tranche) {
      const index = this.tranches.indexOf(tranche);
      confirm("Are you sure you want to delete this tranche?") &&
        this.tranches.splice(index, 1);
    },

    closeTranche() {
      this.trancheDialog = false;
      setTimeout(() => {
        this.editedTranche = Object.assign({}, this.defaultTranche);
        this.editedTrancheIndex = -1;
      }, 300);
    },

    saveTranche() {
      if (this.editedTranche.name !== "") {
        if (this.editedTrancheIndex > -1) {
          Object.assign(
            this.tranches[this.editedTrancheIndex],
            this.editedTranche
          );
        } else {
          this.tranches.push(this.editedTranche);
        }
      }
      this.closeTranche();
    },

    deleteWeightedType(weightedType) {
      const index = this.weightedTypes.indexOf(weightedType);
      confirm("Are you sure you want to delete this type?") &&
        this.weightedTypes.splice(index, 1);
    },

    closeWeightedType() {
      this.weightedTypeDialog = false;
    },

    newWeightedType() {
      this.weightedTypeDialog = true;
    },

    saveWeightedType() {
      if (this.editedWeightedType !== "") {
        this.weightedTypes.push(this.editedWeightedType);
      }

      this.weightedTypeDialog = false;
      this.closeWeightedType();
    },

    deleteExcludedType(excludedType) {
      const index = this.excludedTypes.indexOf(excludedType);
      confirm("Are you sure you want to delete this type?") &&
        this.excludedTypes.splice(index, 1);
    },

    closeExcludedType() {
      this.excludedTypeDialog = false;
    },

    newExcludedType() {
      this.excludedTypeDialog = true;
    },

    saveExcludedType() {
      if (this.editedExcludedType !== "") {
        this.excludedTypes.push(this.editedExcludedType);
      }
      this.excludedTypeDialog = false;
      this.closeExcludedType();
    },

    validatePropertyScores() {
      var ret =
        Math.abs(
          parseFloat(this.propAgeCoef) + parseFloat(this.propQualCoef) - 100.0
        ) < 0.0001
          ? ""
          : "Property score weights must sum to 100%";

      if (ret != "") {
        this.buttonDisabled = true;
      }

      return ret;
    },

    validateCompanyScores() {
      var ret =
        Math.abs(
          parseFloat(this.compRelCoef) +
            parseFloat(this.compTypeCoef) +
            parseFloat(this.compPropCoef) +
            parseFloat(this.compSqftCoef) +
            parseFloat(this.compPropNumCoef) -
            100
        ) < 0.0001
          ? ""
          : "Property score weights must sum to 100%";

      if (ret != "") {
        this.buttonDisabled = true;
      }

      return ret;
    },

    signout() {
      window.sessionStorage.removeItem("token");
      this.$router.push({ path: "/" });
    },

    exportData() {},
  },

  mounted() {
    let jwt = window.sessionStorage.getItem("token");

    if (jwt === null) {
      this.$router.push({ path: "/" });
      return;
    }

    utils.VerifyJWT(jwt, (err) => {
      if (err != null) {
        // Invalid JWT Token (or it has expired)
        window.sessionStorage.removeItem("token");
        this.$router.push({ path: "/" });
      }
    });

    setInterval(() => {
      axios
        .get(url + "/api/score", {
          headers: { Authorization: `Bearer ${jwt}` },
        })
        .then((response) => this.setStatus(response.data))
        .catch(function () {});
    }, 1000);

    axios
      .get(url + "/api/score", {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((response) => this.setForm(response.data))
      .catch(function () {});
  },
};
</script>
